import { useNavigation, type FetcherWithComponents } from '@remix-run/react';

export const useFetcherIsActionRedirect = <T>(
    fetcher: FetcherWithComponents<T>
): fetcher is FetcherWithComponents<T> & { data: NonNullable<T> } => {
    const navigation = useNavigation();
    return (
        fetcher.state === 'loading' &&
        fetcher.formMethod !== null &&
        navigation.formMethod !== 'GET' &&
        // If we have no data we must have redirected
        (fetcher.data === null || typeof fetcher.data === 'undefined')
    );
};
